module.exports = __webpack_public_path__ + "media/public/fonts/QanelasRegular/QanelasRegular-3b215383e229e28d0c72924d5de4e64c.ttf";